import { InformationCircleIcon } from "@heroicons/react/24/solid";
import ItemizedDetailsView from "./ItemizedDetailsView";
import DebitAdjusmentView from "./DebitAdjustmentView";
import Tooltip from "react-tooltip";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  descriptions,
  isAddDebitAdjusment,
  isAttachDebitAdjusment,
} from "../../Completed/atom/atoms";
import { useEffect, useState } from "react";
import { useGetInvoiceDebitAdjustment } from "../../InvoiceCapture/hooks/useInvoiceDebitAdjustment";

interface VendorInvoiceDetailsProps {
  rowData: any;
}

export const VoidedView: React.FC<VendorInvoiceDetailsProps> = ({
  rowData,
}) => {
  const isAddDebitAdj = useRecoilValue(isAddDebitAdjusment);
  const isAttachDebitAdj = useRecoilValue(isAttachDebitAdjusment);
  const [, setDescription] = useRecoilState(descriptions);
  const [debitAdjustment, setDebitAdjustment] = useState<any>([]);
  const [debitAdjustmentRefNbr, setDebitAdjustmentRefNbr] = useState<any[]>([]);
  const {
    data: invoiceDebitAdjustmentData,
    isSuccess: getDebitAdjustmentDataSuccess,
  } = useGetInvoiceDebitAdjustment();

  const getMaskedBankAccount = (
    bankAccount: string | undefined
  ): string | null => {
    return bankAccount ? bankAccount.replace(/.(?=.{4})/g, "x") : "N/A";
  };

  function formatDate(date) {
    if (!date) {
      return "N/A";
    }
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }
  const getDescription = (): string => {
    if (rowData?.length === 0) {
      return "Account#: N/A DUE N/A; Service N/A to N/A";
    }
    const autoPayDescription = rowData?.autoPayName
      ? rowData?.autoPayName?.toLowerCase() === "eft"
        ? getMaskedBankAccount(rowData?.bankAccount)
        : `AUTOPAY ${getMaskedBankAccount(rowData?.bankAccount)}`
      : "";

    const accountNumber = rowData?.accountNumber
      ? rowData?.accountNumber
      : "N/A";
    const dueDate = formatDate(rowData?.duedate);
    const serviceDueDate = formatDate(rowData?.servicePeriodDate);
    const billDueDate = formatDate(rowData?.billingPeriodEndDate);
    const serviceDateRange = `Service date: ${serviceDueDate} to ${billDueDate}`;

    return `Account#: ${accountNumber} ${autoPayDescription} DUE ${dueDate}; ${serviceDateRange}`;
  };

  useEffect(() => {
    if (getDebitAdjustmentDataSuccess && invoiceDebitAdjustmentData) {
      setDebitAdjustmentRefNbr(invoiceDebitAdjustmentData?.data);
    }
  }, [invoiceDebitAdjustmentData]);

  useEffect(() => {
    //From invoiceDebitAdjustment
    const debitAdjRefNbr = debitAdjustmentRefNbr?.filter(
      (x) => x.invoiceBillRefNbr === rowData.billRefNumber
    );
    const debitAdj = Array.from(
      new Set(debitAdjRefNbr?.map((x) => Number(x.debitAdjRefNbr)))
    );
    //From rowData
    const debitAdjustments = Array.from(
      new Set(rowData.debitAdjBillRef?.map((x) => x))
    );
    const combinedDebitAdj = debitAdjustments.concat(debitAdj);

    const results = Array.from(new Set(combinedDebitAdj?.map((x) => x)));
    setDebitAdjustment(results);
  }, [debitAdjustmentRefNbr]);

  useEffect(() => {
    setDescription(getDescription);
  }, []);

  return (
    <>
      <div className="grid md:grid-cols-1 lg:grid-cols-3">
        {/* Left fields */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Service No. Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.accountNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Corporate Office Number:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.storeNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Office Status:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeStatus}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Confie Office Name:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Office Address:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeStreet} {", "} {rowData?.officeCity} {", "}
              {rowData?.officeStateCode} {rowData?.officeZipcode}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Confie Brand:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.officeBrand}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Amount Paid:
            </label>
            <div className="flex flex-row">
              <label className="expandedDataVIP fontExpand">
                {rowData?.amountPaid}
              </label>
              {rowData?.billAdjustment?.length > 0 ? (
                <div className="ml-4">
                  <Tooltip
                    id="voided"
                    place="top"
                    effect="solid"
                    type="info"
                    border={false}
                    arrowColor="#6b7280"
                    backgroundColor="#6b7280"
                    textColor="white"
                  />
                  <InformationCircleIcon
                    data-tip={
                      "Check Debit Adjustment for new Total Amount Paid."
                    }
                    data-for="voided"
                    className="text-white bg-pink-900 rounded-full h-4 w-4"
                  />
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Billing Period Start Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.servicePeriodDate
                ? rowData?.servicePeriodDate &&
                  new Date(rowData?.servicePeriodDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Billing Period End Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.billingPeriodEndDate
                ? rowData?.billingPeriodEndDate &&
                  new Date(rowData?.billingPeriodEndDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Expense Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.expenseAccountDescription}
            </div>
          </div>
        </div>
        {/* end of 1st col */}
        {/* start of 2nd col */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Invoice No.:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.invoiceNumber}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Date Capture:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.dateCapture
                ? rowData?.dateCapture &&
                  new Date(rowData?.dateCapture).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Vendor Name:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.vendorName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Vendor ID:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.vendorCode}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bill Reference:
            </label>
            <div className="flex flex-col">
              <div className="col-span-2 expandedDataVIP fontExpand blueAndBold">
                <label
                  className="underline cursor-pointer"
                  onClick={() => {
                    window.open(
                      `https://acumaticastg.confie.com/Main?CompanyID=Admin+Retail&ScreenId=AP301000&DocType=INV&RefNbr=${rowData?.billRefNumber}`,
                      "_blank"
                    );
                  }}
                >
                  {rowData?.billRefNumber}
                </label>
                {debitAdjustment?.length > 0 ? (
                  <label className="text-green-600 italic"> - Completed</label>
                ) : (
                  ""
                )}
              </div>
              <div>
                {debitAdjustment?.length > 0
                  ? debitAdjustment.map((bill, index) => (
                      <div className="col-span-2 expandedDataVIP fontExpand blueAndBold">
                        <label
                          key={index}
                          className="underline cursor-pointer"
                          onClick={() => {
                            window.open(
                              `https://acumaticastg.confie.com/Main?CompanyID=Admin+Retail&ScreenId=AP301000&DocType=ADR&RefNbr=${bill}`,
                              "_blank"
                            );
                          }}
                        >
                          {bill}
                        </label>
                        <label className="text-pink-700 italic">
                          {" "}
                          - Debit Adjusment
                        </label>
                      </div>
                    ))
                  : ""}
              </div>
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Payment Reference No.:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.paymentRef}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Reference:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankReference}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Reference Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankReferenceDate
                ? rowData?.bankReferenceDate &&
                  new Date(rowData?.bankReferenceDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Bank Account:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.bankAccount
                ? rowData?.bankAccount.replace(/.(?=.{4})/g, "x")
                : null}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Utility Type:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.utilityType}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand">
              Auto Pay:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.autoPayName}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand">
              Description:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {getDescription()}
            </div>
          </div>
        </div>
        {/* end of 2nd col */}
        {/* start of 3rd col */}
        <div className="p-2 divide-y">
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Branch GL:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.branchGL}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Subaccounts:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.glsubaccounts}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Due Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.duedate
                ? rowData?.duedate &&
                  new Date(rowData?.duedate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Previous Balance Amount:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData.previousBalanceAmount}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Draft Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.draftDate
                ? rowData?.draftDate &&
                  new Date(rowData?.draftDate).toLocaleDateString()
                : ""}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Invoice Image:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.invoiceImageAttachment}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Note:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.noteSection}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Created By:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.createdBy}
            </div>
          </div>
          <div className="grid grid-cols-3 p-2">
            <label className="col-span-1 expandedLabelVIP fontExpand ">
              Created Date:
            </label>
            <div className="col-span-2 expandedDataVIP fontExpand">
              {rowData?.createdDate
                ? rowData?.createdDate &&
                  new Date(rowData?.createdDate).toLocaleDateString() +
                    " " +
                    new Date(rowData?.createdDate).toLocaleTimeString(
                      navigator.language,
                      {
                        hour: "2-digit",
                        minute: "2-digit",
                      }
                    )
                : ""}
            </div>
          </div>
        </div>
      </div>
      {/* Debit Adjusment Form */}
      {/* {isAddDebitAdj || isAttachDebitAdj ? (
        <DebitAdjusmentForm
          rowData={rowData}
          debitAdj={debitAdjustmentsData}
          isAddState={isAddDebitAdj}
        />
      ): (
        ""
      )} */}
      {rowData?.debitAdjustmentDetails?.length > 0 &&
      !isAddDebitAdj &&
      rowData?.debitAdjustmentDetails?.length > 0 &&
      !isAttachDebitAdj ? (
        <DebitAdjusmentView data={rowData} />
      ) : (
        ""
      )}
      <ItemizedDetailsView data={rowData} />
    </>
  );
};
